import { inject } from 'vue'

export default function useTranslations() {
  const languageStore = inject('languageStore')

  const t = (key, replacements) => {
    if (!languageStore?.t) return key
    return languageStore.t(key, replacements)
  }

  return {
    languageStore,
    t,
    currentLanguage: languageStore?.currentLanguage,
    supportedLanguages: languageStore?.supportedLanguages
  }
}

